import "core-js/modules/es6.object.assign";
import * as styleUtilities from './styled-utils';
export default Object.assign({}, styleUtilities, {
  primary: '#fb5b21',
  secondary: '#666',
  grey: '#F5F5F1',
  lightest: '#fff',
  darkest: '#000'
});